import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import { useTranslation } from "react-i18next";
import { googleAuthServiceFactory } from "../../services/GoogleAuthServiceImpl";
import { ResponseMessage } from "../../domain/enums/common/ResponseMessageEnum";
import { User } from "../../domain/models/User";
import { userServiceFactory } from "../../services/UserServiceImpl";

interface GoogleLoginButtonProps {
    onSuccess: (curentUser: User) => void;
    onError?: (error: string) => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onSuccess, onError }) => {
    const { t } = useTranslation();

    const handleSuccess = async (credentialResponse: CredentialResponse) => {
        try {
            const response = await googleAuthServiceFactory().loginWithGoogle(credentialResponse.credential);

            if (response === ResponseMessage.SUCCESS) {
                onSuccess(await userServiceFactory().getCurrentUser());
            } else {
                if (onError) onError(t("errors.common"));
            }
        } catch (err: any) {
            if (onError) onError(t("errors.common"));
        }
    };

    return (
        <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => onError && onError(t("errors.common"))}
            // text={}
        />
    );
};

export default GoogleLoginButton;
